<template>
  <v-bottom-navigation horizontal grow fixed active-class="primary">
    <v-btn  
      value="home" 
      border="right"
      @pointerdown.stop.prevent="pointerMode && $router.push({ name: 'home' })"
      @click.stop.prevent="!pointerMode && $router.push({ name: 'home' })"
      to="/home"
    >
      <span>Home</span>

      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-divider vertical v-if="employeeAccess.report && employeeAccess.report.view"></v-divider>

    <v-btn v-if="employeeAccess.report && employeeAccess.report.view"
      value="Report"
      @pointerdown.stop.prevent="
        pointerMode && $router.push({ path: '/reports' })
      "
      @click.stop.prevent="!pointerMode && $router.push({ path: '/reports' })"
      to="/reports"
    >
      <span>Report</span>

      <v-icon>mdi-chart-areaspline</v-icon>
    </v-btn>

    <v-divider vertical></v-divider>

    <v-btn
      value="settings"
      @pointerdown.stop.prevent="
        pointerMode && $router.push({ path: '/settings' })
      "
      @click.stop.prevent="!pointerMode && $router.push({ path: '/settings' })"
      to="/settings"
    >
      <span>Tools</span>

      <v-icon>mdi-tools</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "bottom-navigation",
  data() {
    return {
      pointerMode: "PointerEvent" in window,
      value: "",
    };
  },
  computed: {
    ...mapGetters("employee", ["employee", "employeeAccess"]),
  }
};
</script>

<style scoped>
.activeColor {
  background-color: #253179 !important;
}
</style>